import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigService } from 'src/app/___LOGIC/___common/__config/config.service';
import { EmailService } from 'src/app/___LOGIC/__email/email.service';

@Component({
  selector: 'app-redirect-page',
  templateUrl: './redirect-page.component.html',
  styleUrls: ['./redirect-page.component.css']
})
export class RedirectPageComponent implements OnInit {

  token;
  loading = false;
  expired = false;
  supportEmail;

  moreServices = {
    title: 'Explora todos nuestros servicios',
    array: [
      { title: 'Consultoría para elegir tus estudios', description: 'Videollamada inicial para cononcer tus planes', icon: 'video_call', link: this.configService.getApiUrlRefactor('domainWebapp') },
      { title: 'Guía para obtener el visado de estudiante', description: 'Videollamada inicial para cononcer tus planes y solventar tus dudas.', icon: 'video_call', link: this.configService.getApiUrlRefactor('domainWebapp') },
      /* { title: 'Guía para elegir seguro médico', description: 'Todo lo que necesitas saber para elegir tu seguro médico.', icon: 'security' },
      { title: 'Guía para elegir seguro médico', description: 'Todo lo que necesitas saber para elegir tu seguro médico.', icon: 'security' }, */
      { title: 'Asistencia procesos extranjería', description: 'Los requisitos que debes conocer de la visa para estudiar en España', icon: 'airplanemode_active', link: this.configService.getApiUrlRefactor('domainWebapp') }
    ]
  };
  
  constructor(private route: ActivatedRoute,private http: HttpClient,private emailService: EmailService,private configService: ConfigService) { 
    this.supportEmail = this.emailService.getAdminEmail();
  }

  ngOnInit(): void {
    //Process URL
    if(this.route.snapshot.paramMap.get('token')){
      //this.mode = 'validateToken';
      this.token = this.route.snapshot.paramMap.get('token');
      //this.preRegistered = true;
      this.loading = true;
      this.load();
      //this.signin.get('password').valueChanges.subscribe(value => this.onPasswordInput(value));
    }else{
      debugger
      /* this.pdfInfo.title = 'TITULO DE PDF TRAIDO DE PDF MANAGER';
      this.showGuideDetails = true; */
    }
  }

  async load(){
    let url = this.configService.getApiUrlRefactor('appBase')+"products/productActivation/activateProduct.php?token="+this.token;
    const data = await this.http.get(url).toPromise();
    if(data['success']){
      await new Promise(resolve => setTimeout(resolve, 5000)); // espera 3 segundos
      this.loading = false;
      let link = data['activationData']['url'];
      window.open(link, '_blank');
      /* this.pdfInfo.imageUrl = 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/b3da8c49-0a7f-4f1a-ac08-bdfb63e62600/public';
      this.pdfInfo.pdfUrl = data['guide'].url;
      this.pdfInfo.pdfProduct = data['guide']['FK_ID_product'];
      this.status = data['guide']['paid']; */
    }else{
      this.loading = false;
      data && data['error']? console.log(data['error']) : console.log('Error on token validation');
      this.expired = true;
    }
  }

  // con Promesa y async/await
  async esperarYSeguir() {
    console.log("Inicio");
    await new Promise(resolve => setTimeout(resolve, 10000)); // espera 3 segundos
    console.log("Después de 3 segundos");
  }

  

}
